/**
 * Prix en FCFA pour l'affichage : « 4 100 », jamais « 4100 ». L'API du marché renvoie le montant
 * sous forme de chaîne ; une valeur illisible est rendue telle quelle plutôt que masquée.
 */
export const formaterPrix = (montant: string | number | null | undefined): string => {
  if (montant === null || montant === undefined || montant === '') return '—';
  const nombre = typeof montant === 'number' ? montant : Number(String(montant).replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(nombre)) return String(montant);
  return nombre.toLocaleString('fr-FR', { maximumFractionDigits: 2 });
};
